<div class="sidenav" [ngClass]="{ 'collapsed': !dashboardNavComponent?.isSideNavExpanded }">
    <app-dashboard-nav
        #navComponent
        [clientCode]="clientCode"
        [user]="user"
        [entitlements]="entitlements"
        (revertChanges)="onRevertChanges()"
        (dashboardPropertiesUpdated)="dashboard = $event"
    >
    </app-dashboard-nav>
</div>

<div
    id="layout-wrapper"
    class="layout-wrapper"
    [ngClass]="{ 'collapsed': !dashboardNavComponent?.isSideNavExpanded, 'marginleft': dashboardNavComponent?.isSideNavExpanded }"
>
    <app-hs-dashboard
        #hsDashboard
        [clientCode]="clientCode"
        [isMultiClient]="isMultiClient"
        [user]="user"
        [userEntitlements]="entitlements"
        [userPreferences]="preferences"
        [dashboardPrefs]="dashboardPrefs ?? {}"
        [dashboard]="dashboard"
        [workspace]="workspace"
        [viewMode]="inPresentationMode ? 'view' : 'edit'"
        [widgets]="widgets"
        [inPresentationMode]="inPresentationMode"
        [memberOf]="memberOf"
        [useNewExports]="useNewExports"
        [fuzzyDates]="ddvFuzzyDates"
        [ccFuzzyDates]="fuzzyDates"
        [funds]="funds"
        [clients]="clients ?? []"
        (editRequested)="onEditRequested($event)"
        (cancelEdit)="onCancelEdit()"
        (revertChanges)="onRevertChanges()"
        (saveDashboardWidgets)="onSaveWidgetChangesToServer($event)"
        (dashboardSwitch)="onDashboardSelectedInLeftNav($event)"
        (userPreferencesChange)="savePreferences($event)"
    >
    </app-hs-dashboard>

    <app-dashboard-bar
        [dashboardNote]="dashboardNote"
        [dashboardId]="currentDashboardId"
        [inPresentationMode]="inPresentationMode"
        [isGlobal]="isGlobal"
        [isGlobalEditPartial]="isGlobalEditPartial"
        [fuzzyDates]="ddvFuzzyDates"
        [ccFuzzyDates]="fuzzyDates ?? []"
        [funds]="funds"
        [userPreferences]="preferences"
        [clients]="clients ?? []"
        (deleteDashboardNote)="onDeleteDashboardNote()"
        (saveDashboardNote)="onSaveDashboardNote($event)"
        (filtersRemoved)="saveDashboardFilters($event)"
    >
    </app-dashboard-bar>

    <div #dummyDashboardDiv id="dashboardDummyDiv" class="dummy-dashboard-margin">
        <div class="margin-container"></div>
    </div>

    <div class="dashboard-container" #dashboardContainer>
        <div class="margin-container">
            <canvas id="grid-canvas" #gridcanvas></canvas>
            @if (initializationErrors.length) {
                <ddv-initialization-errors [errors]="initializationErrors"></ddv-initialization-errors>
            } @else {
                <app-dashboard
                    #dashboardComponent
                    [isGlobal]="isGlobal"
                    [isManagingWidget]="false"
                    [entitlements]="entitlements"
                    [user]="user"
                    [fuzzyDates]="fuzzyDates ?? []"
                >
                </app-dashboard>
            }
        </div>

        @if (isDashboardLoading) {
            <div class="loader-parent">
                <span class="loader"></span>
            </div>
        }
    </div>

    <app-socket data-html2canvas-ignore="true"></app-socket>
</div>

<ng-template #saveGlobalTemplate>
    <div class="save-global-message">{{ saveGlobalMessage }}</div>
    <div>{{ saveGlobalNote }}</div>
</ng-template>
